import React from 'react'

const Line = () => {
  return (
    <div className="w-full flex justify-center">
      <div className="w-full max-w-[85rem] border border-neutral-100" />
    </div>
  )
}

export default Line